import { render, staticRenderFns } from "./SDialog.vue?vue&type=template&id=428b91bd&"
import script from "./SDialog.vue?vue&type=script&lang=js&"
export * from "./SDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports